export default "__VITE_ASSET__sWz0$YCb__"